export const SortPriorityOrder = {
  StrategicOngoing: 1,
  StandardOngoing: 2,
  StrategicNotStarted: 3,
  StandardNotStarted: 4,
  StrategicCompleted: 5,
  StrategicEnded: 6,
  StandardCompleted: 7,
};
